// src/authConfig.ts

export const msalConfig = {
  auth: {
    clientId: "17d45425-fdd2-42ea-aa96-37a92dc49794",
    authority: "https://login.microsoftonline.com/e030b0c2-7438-480c-8b0c-0d7c3ae5f098", 
redirectUri: process.env.REACT_APP_REDIRECT_URI!,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};
export const graphTokenRequest = {
  scopes: [
    "https://graph.microsoft.com/Mail.Read",
    "https://graph.microsoft.com/Mail.ReadWrite",
    "https://graph.microsoft.com/Mail.Send",
    "https://graph.microsoft.com/Mail.Send.Shared",
    "https://graph.microsoft.com/User.Read",
    "https://graph.microsoft.com/User.ReadBasic.All",
    "https://graph.microsoft.com/offline_access",
    "https://graph.microsoft.com/Sites.Read.All",
    "https://graph.microsoft.com/Sites.ReadWrite.All",
    "https://graph.microsoft.com/Sites.Manage.All",
    "https://graph.microsoft.com/People.Read"
  ],
};
